import FilePickerViewState from '../store/schema/FilePickerViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('clearSelectedFileProviderItems')(function clearSelectedFileProviderItems(
    viewState: FilePickerViewState
) {
    viewState.selectedFileProviderItems = [];
});
